/**************************************************************************************************/
/** @import Helpers/Components                                                                   **/
/**************************************************************************************************/
import { BaseElement } from '@/Helpers/Components/DataForm/BaseElement'

/**************************************************************************************************/
/** @export Class @name InputSelect                                                              **/
/**************************************************************************************************/
export class InputSelect extends BaseElement
{
	/*************************************************/
	/** @Properties                                 **/
	/*************************************************/
	private options: Array<any>
	private selected: any
	private type: string

	/*************************************************/
	/** @Constructor                                **/
	/*************************************************/
	constructor(key: string, label: string, options: Array<any> = [])
	{
		super()
		this.Key      = key
		this.Label    = label
		this.options  = options
		this.type     = 'InputSelect'
		this.selected = null
		this.setParamsState(this.resolveInputState)
	}

	/*************************************************/
	/** @Methods                                    **/
	/*************************************************/
	public get Options() : Array<any>
	{
		return this.options
	}

	public set Options(options)
	{
		this.options = options
	}

	public get Selected() : any
	{
		return this.selected
	}

	public set Selected(value)
	{
		this.selected = value
	}

	public get Type() : string
	{
		return this.type
	}

	public resolveInputState(self: InputSelect) : boolean | null
	{
		if (self?.selected === null) return null
		return true
	}
}